import React from 'react'
import { Building2 } from 'lucide-react'
import styled from 'styled-components'
import DynamicProfileImage from 'components/commons/DynamicProfileImage'
import { buildOrganizers } from 'modules/events/page/cover/CoverOrganizers'
import colors from 'theme/colors'
import { Card, Label, List, Person, Info, Name, Origin } from './PeopleCard'

const AVATAR_SIZE = '40px'

/**
 * Quem organiza o evento — o produtor principal e os convidados que são
 * produtor ou estabelecimento —, com foto. É o mesmo que a página pública
 * mostra, então qualquer pessoa com acesso à Visão geral vê, colaborador
 * inclusive. Sem co-organizadores, o cartão nem aparece.
 */
export default function EventOrganizers({ event }) {
    if (!event?.co_organizers?.length) {
        return null
    }

    const organizers = buildOrganizers(event)

    return (
        <Card>
            <Label>
                <Building2 size={13} aria-hidden='true' />
                Organizadores · {organizers.length}
            </Label>

            <List>
                {organizers.map(organizer => (
                    <Person key={organizer.key}>
                        <DynamicProfileImage size={AVATAR_SIZE} img={organizer.photo} word={organizer.name} />

                        <Info>
                            <Name>
                                <OrganizerLink href={organizer.href} target='_blank' rel='noopener noreferrer' title={organizer.name}>
                                    {organizer.name}
                                </OrganizerLink>
                            </Name>
                            <Origin>{organizer.role}</Origin>
                        </Info>
                    </Person>
                ))}
            </List>
        </Card>
    )
}

const OrganizerLink = styled.a`
    color: ${colors.nightDark};
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`
